interface TableItem {
  id: string;
}

export default class StaticTable<T extends TableItem> {
  data: T[];

  hash: {
    [id: string]: T;
  };

  ids: string[];

  pick?: T;

  constructor(data: T[], options?: { pick?: string }) {
    const { pick } = options ?? {};
    this.data = data;
    this.ids = data.map((item) => item.id);
    this.hash = data.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
    this.pick = (pick ? this.hash[pick] : this.data[0]) ?? this.data[0];
  }

  get(id: string): T | undefined {
    return this.hash[id];
  }
}
